import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AppConfig } from '../app.config';

import {
    CreateExternalLocationCommand, LocationDetailView, LocationItem,
    PolygonType, RiskAssessmentStatus, SearchView
} from '../contracts';

@Injectable()
export class LocationService {

    constructor(private readonly http: HttpClient) {
    }

    public search(criteria: any): Observable<SearchView<LocationItem>> {
        const url = AppConfig.apiUrls.locations.list();
        const params = new HttpParams()
            .set('searchText', criteria.searchText ? criteria.searchText : '')
            .set('caseWorkerCvr', criteria.caseWorker ? criteria.caseWorker.cvr : '')
            .set('caseWorkerEmail', criteria.caseWorker ? criteria.caseWorker.email : '')
            .set('riskAssessmentStatus', criteria.riskAssessmentStatus ? criteria.riskAssessmentStatus.status : '')
            .set('minScreeningFactor', criteria.minScreeningFactor ? criteria.minScreeningFactor : '')
            .set('maxScreeningFactor', criteria.maxScreeningFactor ? criteria.maxScreeningFactor : '')
            .set('minFactor', criteria.minFactor ? criteria.minFactor : '')
            .set('maxFactor', criteria.maxFactor ? criteria.maxFactor : '')
            .set('screeningContaminant', criteria.screeningContaminant ? criteria.screeningContaminant : '')
            .set('contaminant', criteria.contaminant ? criteria.contaminant : '')
            .set('polygonStatus', criteria.polygonStatus ? criteria.polygonStatus.status : '')
            .set('polygonType', criteria.polygonType ? criteria.polygonType.status : '')
            .set('searchType', criteria.searchType || criteria.searchType === 0 ? criteria.searchType : '')
            .set('orderBy', criteria.orderBy || criteria.orderBy === 0 ? criteria.orderBy : '')
            .set('orderDescending', criteria.orderDescending ? criteria.orderDescending : false)
            .set('continuationToken', criteria.continuationToken ? criteria.continuationToken : '')
            .set('skip', criteria.skip ? criteria.skip : 0)
            .set('take', criteria.take ? criteria.take : '');
        return this.http.get<SearchView<LocationItem>>(url, { params });
    }

    public getGeusData(locationNumber: string): Observable<any> {
        const url = AppConfig.apiUrls.locations.getGeusData(locationNumber);
        return this.http.get<any>(url);
    }

    public getLocationDetail(id: string): Observable<LocationDetailView> {
        const url = AppConfig.apiUrls.locations.getById(id);
        return this.http.get<LocationDetailView>(url);
    }

    public createLocation(command: CreateExternalLocationCommand): Observable<any> {
        const url = AppConfig.apiUrls.locations.createExternal();
        return this.http.post(url, command);
    }

    public reassessPolygon(
        id: string, polygonType: PolygonType,
        reassessToStatus: RiskAssessmentStatus, comment: string): Observable<any> {
        const url = AppConfig.apiUrls.locations.reassessPolygon(id);
        const request = {
            polygonType,
            reassessToStatus,
            comment
        };
        return this.http.post(url, request);
    }

    public getLocationsFromCache(key: string): SearchView<LocationItem> {
        const json = sessionStorage.getItem(key);
        if (!json) {
            return SearchView.empty<LocationItem>();
        }
        return JSON.parse(json) as SearchView<LocationItem>;
    }

    public setLocationsToCache(key: string, res: SearchView<LocationItem>): void {
        const json = JSON.stringify(res);
        sessionStorage.setItem(key, json);
    }

    public removeLocationsToCache(key: string): void {
        sessionStorage.removeItem(key);
    }

    public searchDkJordLocations(locationReferences: string): Observable<any> {
        const url = AppConfig.apiUrls.locations.searchDkJordLocations(locationReferences);
        return this.http.get<any>(url);
    }

    public forceCreateLocation(locationReferences: string): Observable<any> {
        const url = AppConfig.apiUrls.locations.forceCreateLocation();
        const request = {
            number: locationReferences,
        };
        return this.http.post(url, request);
    }
}
